import { render, staticRenderFns } from "./BcPagination.vue?vue&type=template&id=215f4985"
import script from "./BcPagination.vue?vue&type=script&lang=js"
export * from "./BcPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports